import { Seo } from "@/components/Seo";
import { PageHero } from "@/components/PageHero";
import { FaqAccordion } from "@/components/faq/FaqAccordion";

export default function FAQ() {
  return (
    <>
      <Seo
        title="FAQ"
        description="Frequently asked questions about RKG NATURALS trade and shipping."
        path="/faq"
      />
      <div data-testid="faq-page">
        <PageHero eyebrow="FAQ" title="Frequently Asked Questions" />
        <FaqAccordion />
      </div>
    </>
  );
}
